const STYLES = {
  Available:
    "bg-[#E8F2EC] text-[#1E5235] border-[#B9DEC8] dark:bg-[#122A1E] dark:text-[#6EE7B7] dark:border-[#1B4D36]",
  "Pending Lease":
    "bg-[#FEF8E7] text-[#8A6112] border-[#F3DE9A] dark:bg-[#2E2410] dark:text-[#FDE68A] dark:border-[#543F13]",
  Rented:
    "bg-[#F5EFEB] text-[#874D2E] border-[#DFC7BA] dark:bg-[#2A1911] dark:text-[#FCA5A5] dark:border-[#4F2618]",
};

export default function StatusBadge({ status, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-mono uppercase tracking-[0.15em] ${STYLES[status] || STYLES.Available}`}
    >
      {status}
    </span>
  );
}
